import { useState, useEffect } from "react";
import { Clock } from "lucide-react";

// A live-ticking clock rendered in the given timezone (defaults to browser local).
export function LiveClock({ timezone, className = "" }) {
    const [now, setNow] = useState(new Date());

    useEffect(() => {
        const t = setInterval(() => setNow(new Date()), 1000);
        return () => clearInterval(t);
    }, []);

    let time = "";
    let date = "";
    try {
        time = now.toLocaleTimeString("en-GB", {
            timeZone: timezone,
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        });
        date = now.toLocaleDateString("en-GB", {
            timeZone: timezone,
            weekday: "short",
            day: "2-digit",
            month: "short"
        });
    } catch {
        time = now.toLocaleTimeString();
        date = now.toLocaleDateString();
    }

    return (
        <div className={`inline-flex items-center gap-2 rounded-lg bg-gray-900 text-white px-3 py-2 ${className}`}>
            <Clock className="h-4 w-4 text-gray-300" />
            <div className="leading-tight">
                <div className="text-lg font-bold tabular-nums">{time}</div>
                <div className="text-[10px] text-gray-300 uppercase tracking-wide">
                    {date}
                    {timezone ? ` · ${timezone}` : ""}
                </div>
            </div>
        </div>
    );
}

export default LiveClock;
